import type { ReactNode } from "react";

type Tone = "pos" | "warn" | "neg" | "accent";

/**
 * Status pill. Quiet by default: pass a tone only when a human needs to act.
 * That is the "exceptions earn ink" rule.
 */
export function Chip({ tone, dot, children }: {
  tone?: Tone;
  /** Adds a leading status dot. */
  dot?: boolean;
  children: ReactNode;
}) {
  return (
    <span className={["chip", tone && `chip-${tone}`].filter(Boolean).join(" ")}>
      {dot && <span className={["dot", tone && tone !== "accent" && `dot-${tone}`].filter(Boolean).join(" ")} />}
      {children}
    </span>
  );
}
